export default __webpack_public_path__ + "static/media/Cloud File Storage.4ccef1ac.png";